import moment from "moment";
import { roundDownToWholeMinutes } from "../../../helpers/time";

const CREATED_OR_BLANK = "Z05";
const ENTERED_NOT_PROCESSED = "Z10";

export const isInApprovableState = ts =>
  ts.calculatedStatusCode === ENTERED_NOT_PROCESSED && ts.submitted;

export const isInEditableState = ts =>
  ts.calculatedStatusCode === CREATED_OR_BLANK ||
  ts.calculatedStatusCode === ENTERED_NOT_PROCESSED;

export const isNotBlank = ts => ts.calculatedStatusCode !== CREATED_OR_BLANK;
export const latestView = timesheets => timesheets.filter(isInApprovableState);

export const checkIfDateIsLastWeek = date => {
  const inputWeek = moment(date).isoWeek();
  const nowWeek = moment().isoWeek();
  return nowWeek > inputWeek || (nowWeek === 1 && inputWeek === 52);
};

export const isInSubmittedStateOrLastWeek = ts => {
  if (ts.calculatedStatusCode === ENTERED_NOT_PROCESSED) {
    if (ts.submitted || checkIfDateIsLastWeek(ts.endDate)) return true;
    return false;
  }
  return true;
};

export const archiveView = timesheets =>
  timesheets
    .filter(isNotBlank)
    .filter(ts => latestView(timesheets).indexOf(ts) === -1)
    .filter(isInSubmittedStateOrLastWeek);

export const showableTimesheets = timesheets => {
  const latestTimesheets = latestView(timesheets);
  const archiveTimesheets = archiveView(timesheets);
  return latestTimesheets.concat(archiveTimesheets);
};

// returns most recent Saturday
export const lastWeekEnd = () => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return new Date(today.setDate(today.getDate() + 6 - today.getDay()));
};

export const weekEarlier = d => {
  const tmpDate = new Date(d);
  tmpDate.setDate(d.getDate() - 7);
  return tmpDate;
};

// returns array of last 12 Sunday dates
export const last12Sundays = () =>
  [...Array(11).keys()].reduce(
    acc => acc.concat(weekEarlier(acc[acc.length - 1])),
    [lastWeekEnd()]
  );

export const removeRoundingErrors = rows =>
  rows.map(row => {
    console.log("start");
    console.log(row);
    const columns = row.columns.map(col => ({
      ...col,
      StandardPayQty: col.StandardPayQty.map(val =>
        roundDownToWholeMinutes(val)
      )
    }));
    console.log(columns);
    const standardRateTotals = row.standardRateTotals.map(total => {
      const newTotal = { ...total };
      if (total.invoiceQty) {
        newTotal.invoiceQty = roundDownToWholeMinutes(total.invoiceQty);
      }
      if (total.PayQty) {
        newTotal.PayQty = roundDownToWholeMinutes(total.PayQty);
      }
      return newTotal;
    });
    console.log(standardRateTotals);
    return { ...row, columns, standardRateTotals };
  });

export const calculateTimesheetStatus = row => {
  let timesheetStatus = "";
  if (row.status === "approved") timesheetStatus = "Approved";
  if (row.status === "rejected") timesheetStatus = "Rejected";
  if (row.status === "pending_approval") timesheetStatus = "Pending";
  return timesheetStatus;
};

export const parseCostCentre = costCentreString => {
  const text = costCentreString
    .split("-")[0]
    .split(" ")
    .reduce((acc, elem, i) => (i === 0 ? "" : `${acc} ${elem}`), "")
    .trim();
  return {
    numericalCode: costCentreString.split(" ")[0],
    letterCode: costCentreString.split("- ")[1],
    text
  };
};
